export const getSequencePreviewMenuButtonProps = ({ isOwner, isPrivilegedUser }) => {
  const canManage = isOwner || isPrivilegedUser;
  return { visible: canManage, menuItems: { edit: { visible: isOwner } } };
};
